var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "flagged-table",
    },
    [
      _c("table-header", {
        attrs: {
          "page-size": _vm.tableHeaderFilters.pageSize,
        },
        on: {
          "page-size-changed": _vm.onPageSizeChanged,
          "search-triggered": _vm.onTriggerSearch,
          "clear-search-term": _vm.onClearSearchTerm,
        },
      }),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        attrs: {
          "grid-options": _vm.gridOptions,
        },
      }),
      _c("flagged-costs-lightbox", {
        ref: _vm.REF_CONSTANTS.FLAGGED_COSTS_LIGHTBOX,
        on: {
          "saved:form": _vm.refreshData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }